import React from 'react';
import classNames from 'classnames';

interface Props {
    className?: string;
}

export default function BetaNotificationLabel(props: Props) {
    return (
        <div className={classNames('premium-notification-label-container', props.className)}>
            <label className='premium-notification-label blue'>Beta</label>
            <p className='premium-notification-info'>
                Deze notificatie is als beta beschikbaar. Kan nog instabiel zijn.<br/>We zijn benieuwd naar jouw feedback
            </p>
        </div>
    )
}